import { store } from '../../store/store';
import { getSystemCode } from '../../utils/getSystemCode';
import { getRecaptchaToken } from '../recaptcha';

export const apiClient = async (endpoint: string, options: RequestInit = {}): Promise<Response> => {
  const { VITE_BASE_API_VERSION, VITE_BASE_API_URL } = import.meta.env;
  const storeSnapshot = store.getSnapshot();
  const session = storeSnapshot.context.app.session;
  const systemCode = getSystemCode(storeSnapshot.context.urlParams?.rs);
  const recaptchaToken = await getRecaptchaToken();
  const defaultHeaders: HeadersInit = {
    'content-type': 'application/json',
    traceparent: '', // TODO: Replace with OTEL trace id if available
    'x-date-override': new Date().toISOString(),
    'x-recaptcha-token': recaptchaToken ?? '',
  };
  if (session?.id) {
    defaultHeaders['x-session-id'] = session.id;
    defaultHeaders['x-interaction-id'] = `${systemCode}:${session.id}`; //interaction ID prefixed with systemCode e.g. DandG_IPR for WIB tracking
  }

  const mergedHeaders = {
    ...defaultHeaders,
    ...options.headers,
  };
  const response = await fetch(`${VITE_BASE_API_URL}/${VITE_BASE_API_VERSION}${endpoint}`, {
    ...options,
    headers: mergedHeaders,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

export const get = async <T>(endpoint: string, options?: RequestInit): Promise<T> => {
  const response = await apiClient(endpoint, { method: 'GET', ...options });
  return response.json() as Promise<T>;
};

export const post = async <T>(
  endpoint: string,
  body?: unknown,
  headers?: Record<string, string>,
): Promise<{ data: T; statusCode: number }> => {
  const response = await apiClient(endpoint, {
    method: 'POST',
    body: body ? JSON.stringify(body) : undefined,
    headers,
  });

  const data = await response.json();
  return { data, statusCode: response.status };
};
